import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  page: {
    display: "flex",
    flexDirection: "column",
    padding: "16px 20px 24px",
    boxSizing: "border-box",
    gap: 12
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16
  },
  title: {
    fontWeight: 700,
    fontSize: "1.15rem"
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  footer: {
    display: "flex",
    justifyContent: "center"
  },
  importButton: {
    minWidth: 240,
    padding: "12px 32px",
    fontSize: "1.1rem"
  },
  tableWrap: {
    maxHeight: "calc(100vh - 260px)",
    overflow: "auto"
  },
  indexCell: {
    width: 48,
    color: "#757575"
  },
  statusCell: {
    minWidth: 220
  }
}));

export default useStyles;
